import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const RegistrationServiceConfigSchema = serviceConfigSchema;
// ============================================================================
// DTO Schema
// ============================================================================
const RegistrationServiceConfigDtoSchema = serviceConfigSchema;

export { RegistrationServiceConfigDtoSchema, RegistrationServiceConfigSchema };
//# sourceMappingURL=RegistrationServiceConfig.js.map
